import {writable} from 'svelte/store';

export enum Language {
  EN = 'en',
  DE = 'de'
}

// Get language from browser settings
const browserLanguage = navigator.language.split('-')[0] as Language;

// Get language from local storage
const storedLanguage = localStorage.getItem('language') as Language;

// Use language from local storage. If not set, detect if the browser language is german, if not, fallback to english
const initialLanguage = storedLanguage
  ? storedLanguage
  : browserLanguage === Language.DE
  ? Language.DE
  : Language.EN;

export const selectedLanguage = writable<Language>(initialLanguage);

// Set the selected language to the local storage when it is manually changed
let isInitialValue = true;

selectedLanguage.subscribe(value => {
  if (!isInitialValue) {
    localStorage.setItem('language', value);
  } else {
    isInitialValue = false;
  }
});
